<template>
  <div>
    <b-modal :id="ModalId" size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" centered :visible="true" :title="TitleWindow" @ok="this.emitEventOK" @hide="this.emitEventHide" :cancel-title="$t('Shared.BtnCancel')"> 
        <Loading v-bind:IsLoading="this.load" /> 

      <b-row>
        <b-col lg="8" md="8" sm="12">
            <MdSelect
                v-bind:Label="'Administered By'"
                data-field="Therapist"
                v-bind:Options="therapistList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:ModelArray="therapistModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownTherapist"
            />
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <MdCheckBox
              v-bind:Label="$t('MdNote.Sign')"
              v-bind:ClassProp="'AlignCheck'"
              v-bind:CheckedValue="true"
              v-bind:UncheckedValue="false"
              v-model="isSigned"                   
              v-on:change="onSignPassword"/>
        </b-col> 
        <b-col lg="8" md="8" sm="12">
             <MdSelect
                v-bind:Label="'Witnessed By'"
                data-field="Witness"
                v-bind:Options="witnessList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:ModelArray="witnessModel"                       
                v-bind:Multiple="false"
                :Input="ChangeDropDownWitness"
            />
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <MdCheckBox
              v-bind:Label="$t('MdNote.Sign')"
              v-bind:ClassProp="'AlignCheck'"
              v-bind:CheckedValue="true"
              v-bind:UncheckedValue="false"
              v-model="isWitness"                   
              v-on:change="onSignWitness"/>
        </b-col> 
      </b-row>

      <MdPasswordDlg v-if="showSignPassword" 
        v-bind:Type="TypePassWord"
        v-bind:EmployeeCode="EmployeeCodeSelected"
        @getModalPassword="onModalPasswordResult($event)"
    />
    </b-modal>
  </div>
</template>

<script>

import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading';
import GlobalService from '@/services/global.service' 
import HighAlertAssessmentNotes from '@/services/highalertassessmentnotes.service' 
import { EventBus } from '@/event-bus.js';

export default {
    name: 'MdHighAlertAssessmentNotes',
    mixins: [ShowMessage],
    props: {
     ModalId: String,
     PatientCode:String,
     TitleWindow: String,
     DateFrom:String,    
     RecordId:String,
     RecNo:Number,
     ForUsefromMars:Boolean,
     MarsParam:Object
   },
   components:{Loading},
    data() {
      return {         
        clickOK: false,

        therapistModel: {},
        witnessModel: {},
        therapistList: [],
        witnessList: [],
        
        isSigned: false,
        isWitness: false,
        showSignPassword: false,
        TypePassWord: '',
        EmployeeCodeSelected: '',

        load: true,
        pendingChanges: false,
        params: {
          HeaderID: null,
          TitleRecNo: null
        },
        isEditing: false,
        data: {
          'HeaderID': null,
          'TherapistCode': null,
          'IsSigned': 'N',
          'WitnessCode': null,
          'IsSignedWitness': 'N',
          'SysDate': null,
          'SysUser': null,
          'PatientCode': null,
          'TitleRecNo': null
        }
      }
    },
    
    methods:{


      onModalPasswordResult(result) {        
        if(result.type === 'Sign'){
          if(result.status !== true) {
            this.showMessage(this.$t('Shared.VerifyPassword'),result.message,"error");
            this.isSigned = false;
          }else{
            this.isSigned = true;
          }
        }

         if(result.type === 'Witness'){
          if(result.status !== true) {
            this.showMessage(this.$t('Shared.VerifyPassword'),result.message,"error");
            this.isWitness = false;
          }else{
            this.isWitness = true;
          }
        }
        this.showSignPassword = false;      
      },

      onSignPassword(value) {
        this.TypePassWord = 'Sign';
        this.EmployeeCodeSelected = value ? this.therapistModel.code : '';
        this.showSignPassword = value;        
        this.isSigned = value;
      },

      onSignWitness(value) {
        this.TypePassWord = 'Witness';
        this.EmployeeCodeSelected = value ? this.witnessModel.code : '';
        this.showSignPassword = value;        
        this.isWitness = value;
      },

      async getEmployees(){
           await GlobalService.getEmployeeActive()
                .then((response) => {
                    if(response.status == '200'){
                        this.witnessList = response.data;
                        this.therapistList = response.data;
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      async getHighAlertAssessmentNotes(){
           this.params.HeaderID = this.RecordId.trim(),
           this.params.TitleRecNo = this.RecNo

           await HighAlertAssessmentNotes.getAll(this.params)
                .then((response) => {
                    if(response.status == '200'){
                        if (response.data && response.data[0].therapistCode) {
                          this.therapistModel = this.therapistList.find(x => x.code == response.data[0].therapistCode);
                          this.data = response.data[0]
                          this.isEditing = true
                        }
                        if (response.data && response.data[0].witnessCode) {
                          this.witnessModel = this.witnessList.find(x => x.code == response.data[0].witnessCode);
                        }
                        if (response.data && response.data[0].isSigned) {
                          this.isSigned = response.data[0].isSigned == 'Y' ? true : false
                        }
                        if (response.data && response.data[0].isSignedWitness) {
                          this.isWitness = response.data[0].isSignedWitness == 'Y' ? true : false
                        }
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      async addHighAlertAssessmentNotes(){
           this.data.HeaderID = this.RecordId.trim(),
           this.data.TherapistCode = this.therapistModel.code
           this.data.IsSigned = 'Y'
           this.data.WitnessCode = this.witnessModel.code
           this.data.IsSignedWitness = 'Y'
           this.data.PatientCode = this.PatientCode
           this.data.TitleRecNo = this.RecNo

           await HighAlertAssessmentNotes.Add(this.data)
                .then((response) => {
                    if(response.status == '200'){
                        //TODO: Show message
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      async UpdHighAlertAssessmentNotes(){
           this.data.HeaderID = this.RecordId.trim(),
           this.data.TherapistCode = this.therapistModel.code
           this.data.IsSigned = 'Y'
           this.data.WitnessCode = this.witnessModel.code
           this.data.IsSignedWitness = 'Y'
           this.data.PatientCode = this.PatientCode
           this.data.TitleRecNo = this.RecNo

           await HighAlertAssessmentNotes.Update(this.data.recNo,this.data)
                .then((response) => {
                    if(response.status == '200'){
                        //TODO: Show message
                    }                             
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
      },

      ChangeDropDownTherapist(value) {
        if(value){
          this.therapistModel = value;  
          this.isSigned = false;    
        }else{
          this.therapistModel = {
            "code": "",
            "firstName": "",
            "fullName": "",
            "lastName": "",
          }
          this.isSigned = false;
        } 
      },

      ChangeDropDownWitness(value) {
         if(value){
          this.witnessModel = value;  
          this.isWitness = false;    
        }else{
          this.witnessModel = {
            "code": "",
            "firstName": "",
            "fullName": "",
            "lastName": "",
          }
          this.isWitness = false;
        } 
      },

      Save(handled) {
        let abortSave = false
        if (!this.isSigned || !this.isWitness) {
          this.showMessage(this.$tc('Msg.Error'), this.$t('MdPainAssessmentNotesOutCome.SingBeforeMsg'),"error");
          abortSave = true
          handled.preventDefault()
        }

        if (this.therapistModel && this.therapistModel.code == this.witnessModel.code) {
          this.showMessage(this.$tc('Msg.Error'), 'Administrator and witness cannot be the same',"error");
          abortSave = true
          handled.preventDefault()
        }
        this.clickOK = false
        
        if (!abortSave) {
          if (!this.isEditing) {
            this.addHighAlertAssessmentNotes()
          } else {
            this.UpdHighAlertAssessmentNotes()
          }
        }

        this.$emit('getCodeConditionOK');
      },

      emitEventOK(){ 
        this.clickOK = true;    
      },

      emitEventHide(handled){
        if (this.pendingChanges && !this.clickOK) {
        handled.preventDefault()
        this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.TitleWindow,
          okTitle: this.$t('Shared.Save'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
          .then(value => {
            if(!value){
              this.$emit('getCancel');
              this.ResetProps();
            }
          })		
        } else {
            if(this.clickOK) {
              this.Save(handled)
            } else {
                this.$emit('getCancel');
                this.ResetProps();
            }
        }
      },

      ResetProps(){
        
      },

      beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
    },

  async mounted() {
    await this.getEmployees()
    await this.getHighAlertAssessmentNotes()
  },

  created () {
     EventBus.$on("onChanged", function (e) {       
          this.pendingChanges = e.Changed
     }.bind(this));
     window.addEventListener('beforeunload', this.beforeWindowUnload)
  },

  beforeDestroy () {
  },
}

</script>